<template>
  <!-- TODO: workaround for modal video on safari browser -->
  <!-- What is the problem: in safari, the video modal only appears inside its container -->
  <!-- and because of that, when it is activated from inside the HamburgerMenu component -->
  <!-- it will only render partially inside that component, and that's not what we want. -->
  <!-- This approach aim to solve that problem having the video modal on the "root" view -->
  <!-- This way, it will render correctly from every where.                              -->
  <!-- And to achieve that, in every instance of SubMenuHeader is necessary to emit   -->
  <!-- the event "showVideo" to handle it here.                                          -->
  <div>
    <router-view @showVideo="showVideo"/>
    <VideoModal v-if="videoEnabled" :show="showVideoModal" :show-note="showNoteInVideo" @dismiss="dismissHandler" />

    <div v-if="$store.state.isLoading" class="modal-mask align-content-center">
      <div class="modal-wrapper">
        <div class="row">
          <div class="col">
            <div class="p-3 spinner-box">
              <img src="../assets/images/spinner_purple_64x64.gif" class="spinner shadow rounded-circle">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VideoModal from "@/components/SharedComponents/VideoModal";

export default {
  'name': 'MainContainer',
  components: { VideoModal },
  data() {
    return {
      'videoEnabled': this.$store.state.isTutorialVideoEnabled,
      'showVideoModal': this.$store.state.showVideoTutorial,
      'showNoteInVideo': true,
      'isLoading': false
    }
  },
  'methods': {
    showVideo() {
      if (this.videoEnabled) {
        this.showVideoModal = true
      }
    },
    dismissHandler() {
      this.showVideoModal = false;
      this.showNoteInVideo = false
    }
  }
}
</script>

<style scoped>
.spinner {
  display: flex;
  width: 35px;
  height: 35px;
}

.spinner-box {
  width: 51px;
  height: 51px;
  display: flex;
  margin: auto;
  background-color: #d0d0d0;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  z-index: 10000;
}
</style>
